import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// withCredentials sends httpOnly auth cookies. Tokens are no longer stored in
// localStorage to avoid XSS exposure.
const client = axios.create({ baseURL: API, withCredentials: true });

export function formatError(err) {
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || 'Something went wrong';
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === 'string' ? e.msg : JSON.stringify(e))).filter(Boolean).join(' ');
  return String(detail);
}

export default client;
